type LolTradingTeamStatsKeys = 'baron' | 'dragon' | 'inhibitor' | 'tower' | 'kills';

const LOL_STATS_ORDER: LolTradingTeamStatsKeys[] = [
  'tower',
  'inhibitor',
  'baron',
  'dragon',
  'kills'
];

const LOL_STATS_WITH_PREDICTION: LolTradingTeamStatsKeys[] = ['dragon'];

const TRADER_INPUTS_CATEGORY_MAPPING: Record<string, TraderInputItem['category']> = {
  main: 'game'
};

export type { LolTradingTeamStatsKeys };
export { LOL_STATS_ORDER, LOL_STATS_WITH_PREDICTION, TRADER_INPUTS_CATEGORY_MAPPING };
